import Cookies from 'js-cookie';
import { isMl3App, isAndroid, isiOS } from './DeviceOptions';
import { sleep } from './Utils';

const originalSet = Cookies.set;

Cookies.originalSet = originalSet;

Cookies.set = async (name, value, options) => {
  originalSet(name, value, options);
  if (isMl3App) {
    if (isAndroid) {
      if (window.maplife) {
        window.maplife.setCookie(name, value);
      }
    } else if (isiOS) {
      while (!document.body) {
        await sleep();
      }
      window.location.href = `native://setCookie("${name}", "${value}")`;
    }
  }
};

export default Cookies;
